import { AfterViewInit, Component, Inject, Input, Pipe, SecurityContext } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { DOCUMENT, NgClass, NgFor, NgIf } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-footer-columns',
  standalone: true,
  imports: [MatIconModule, SocialLinksComponent, NgFor, NgIf, ],
  templateUrl: './footer-columns.component.html',
  styleUrl:'./footer-columns.component.scss'
})
export class FooterColumnsComponent{

    constructor(
        private _domSanitizer: DomSanitizer,
        @Inject(DOCUMENT) private _document: Document

    ){}


@Input() data:any;


sanitize(content:string){
    return this._domSanitizer.bypassSecurityTrustHtml(content)
}






}
